import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-68602390"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "userManageView" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { style: {"text-align":"center"} }
const _hoisted_4 = { class: "arco-upload-list-picture custom-upload-avatar" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "arco-upload-list-picture-mask" }

import { onMounted, ref, watchEffect } from "vue";
import message from "@arco-design/web-vue/es/message";
import moment from "moment";
import { useRouter } from "vue-router";
import { FileItem, Message } from "@arco-design/web-vue";
import { User } from "../../../generated/models/User";
import { UserControllerService } from "../../../generated/services/UserControllerService";
import { FileControllerService, UserAddRequest } from "../../../generated";


export default /*#__PURE__*/_defineComponent({
  __name: 'UserManageView',
  setup(__props) {

document.title = "用户管理";

const router = useRouter();

const file = ref();

let userAvatarImg = "";
const userInfo = ref<User>({
  userName: "",
  userAccount: "",
  userRole: "",
  userAvatar: "",
  userProfile: "",
});

const user = ref<UserAddRequest>({
  userName: "",
  userAccount: "",
  userPassword: "",
  userRole: "",
  userProfile: "",
});

const dataList = ref([]);
const total = ref(0);
const searchParams = ref({
  id: undefined,
  userAccount: "",
  userName: "",
  pageSize: 10,
  current: 1,
});

const loadData = async () => {
  const res = await UserControllerService.listUserByPageUsingPost({
    ...searchParams.value,
    sortField: "createTime",
    sortOrder: "descend",
  });
  if (res.code === 0) {
    dataList.value = res.data.records;
    total.value = res.data.total;
  } else {
    message.error("加载失败，" + res.message);
  }
};

/**
 * 监听 searchParams 变量，改变时触发页面的重新加载
 */
watchEffect(() => {
  loadData();
});

/**
 * 页面加载时，请求数据
 */
onMounted(() => {
  loadData();
});

const columns = [
  {
    title: "id",
    dataIndex: "id",
    align: "center",
  },
  {
    title: "账号",
    dataIndex: "userAccount",
    align: "center",
  },
  {
    title: "昵称",
    dataIndex: "userName",
    align: "center",
  },
  {
    title: "邮箱",
    dataIndex: "email",
    align: "center",
  },
  {
    title: "头像",
    slotName: "userAvatar",
    align: "center",
    width: 64,
  },
  {
    title: "简介",
    dataIndex: "userProfile",
    align: "center",
  },
  /*  {
      title: "性别",
      dataIndex: "gender",
      align: "center",
    },*/
  {
    title: "角色",
    slotName: "userRole",
    align: "center",
  },
  {
    title: "创建时间",
    slotName: "createTime",
    align: "center",
  },
  {
    title: "更新时间",
    slotName: "updateTime",
    align: "center",
  },
  {
    title: "操作",
    slotName: "optional",
    align: "center",
  },
];
/**
 * 分页
 * @param page
 */
const onPageChange = (page: number) => {
  searchParams.value = {
    ...searchParams.value,
    current: page,
  };
};

/**
 * 分页大小
 * @param size
 */
const onPageSizeChange = (size: number) => {
  searchParams.value = {
    ...searchParams.value,
    pageSize: size,
  };
};

// 弹窗是否可见
const updateUserVisible = ref(false);
const addUserVisible = ref(false);
/**
 * 打开弹窗,获取到用户信息
 */
const openUpdateUserModal = async (userId: any) => {
  const res = await UserControllerService.getUserByIdUsingGet(userId);
  userInfo.value = { ...res.data, userPassword: "" };
  // 从表单中获取的用户头像
  userAvatarImg = userInfo.value.userAvatar as string;
  updateUserVisible.value = true;
};
const openAddUserModal = () => {
  addUserVisible.value = true;
};

const closeUpdateUserModel = () => {
  updateUserVisible.value = false;
};
const closeAddUserModel = () => {
  addUserVisible.value = false;
};

/**
 * 删除
 * @param user
 */
const doDelete = async (user: User) => {
  const res = await UserControllerService.deleteUserUsingPost({
    id: user.id,
  });
  if (res.code === 0) {
    message.success("删除成功");
    loadData();
  } else {
    message.error("删除失败");
  }
};

/**
 * 上传头像
 */
const uploadAvatar = async () => {
  const res = await FileControllerService.uploadFileUsingPost(
    file?.value.file,
    "user_avatar"
  );
  if (res.code === 0) {
    userAvatarImg = res.data;
    Message.success("上传成功，点击确认即可修改头像");
  } else {
    Message.error("上传失败！" + res.data);
  }
};

const onChange = async (_: never, currentFile: FileItem) => {
  file.value = {
    ...currentFile,
  };
};

/**
 * 更新用户
 */
const updateUser = async () => {
  const res = await UserControllerService.updateUserUsingPost({
    ...userInfo.value,
    userAvatar: userAvatarImg,
  });
  if (res.code === 0) {
    Message.success("更新成功！");
    updateUserVisible.value = false;
    loadData();
  } else {
    Message.error("更新失败！", res.msg);
  }
};

/**
 * 创建用户
 */
const addUser = async () => {
  const res = await UserControllerService.addUserUsingPost(user.value);
  if (res.code === 0) {
    message.success("创建成功");
    addUserVisible.value = false;
    // 更新数据
    loadData();
  } else {
    message.error("创建失败，" + res.message);
  }
};

/**
 * 封号
 * @param userId
 */
const banUser = async (userId: number) => {
  const res = await UserControllerService.banUserUsingPost({ id: userId });
  if (res.code == 0) {
    Message.success("封禁成功");
    loadData();
  } else {
    Message.error("封禁失败！", res.msg);
  }
};
/**
 * 解封
 * @param userId
 */
const normalUser = async (userId: number) => {
  const res = await UserControllerService.normalUserUsingPost({ id: userId });
  if (res.code == 0) {
    Message.success("解封成功");
    loadData();
  } else {
    Message.error("解封失败！", res.msg);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_input_search = _resolveComponent("a-input-search")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_input_password = _resolveComponent("a-input-password")!
  const _component_a_option = _resolveComponent("a-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_IconEdit = _resolveComponent("IconEdit")!
  const _component_a_upload = _resolveComponent("a-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_form, {
      model: searchParams.value,
      layout: "inline",
      style: {"justify-content":"center","align-content":"center","margin":"25px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form_item, { field: "id" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchParams.value.id) = $event)),
              placeholder: "搜索id",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "id" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input, {
              modelValue: searchParams.value.userAccount,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchParams.value.userAccount) = $event)),
              placeholder: "搜索账号",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, { field: "userName" }, {
          default: _withCtx(() => [
            _createVNode(_component_a_input_search, {
              modelValue: searchParams.value.userName,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchParams.value.userName) = $event)),
              placeholder: "搜索呢称",
              style: {"min-width":"220px","border-radius":"10px"}
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }),
        _createVNode(_component_a_form_item, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              type: "outline",
              shape: "round",
              status: "normal",
              onClick: openAddUserModal
            }, {
              default: _withCtx(() => [
                _createTextVNode("创建 ")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model"]),
    _createVNode(_component_a_table, {
      "column-resizable": true,
      columns: columns,
      data: dataList.value,
      pagination: {
        showTotal: true,
        pageSize: searchParams.value.pageSize,
        current: searchParams.value.current,
        total: total.value,
        showJumper: true,
        showPageSize: true,
      },
      onPageChange: onPageChange,
      onPageSizeChange: onPageSizeChange
    }, {
      userAvatar: _withCtx(({ record }) => [
        _createVNode(_component_a_avatar, {
          size: 70,
          shape: "circle"
        }, {
          default: _withCtx(() => [
            _createElementVNode("img", {
              alt: "userAvatar",
              src: record.userAvatar
            }, null, 8, _hoisted_2)
          ]),
          _: 2
        }, 1024)
      ]),
      userRole: _withCtx(({ record }) => [
        (record.userRole === 'user')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 0,
              color: "arcoblue"
            }, {
              default: _withCtx(() => [
                _createTextVNode("普通用户 ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (record.userRole === 'admin')
          ? (_openBlock(), _createBlock(_component_a_tag, {
              key: 1,
              color: "green"
            }, {
              default: _withCtx(() => [
                _createTextVNode("管理员")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      createTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.createTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      updateTime: _withCtx(({ record }) => [
        _createTextVNode(_toDisplayString(_unref(moment)(record.updateTime).format("YYYY-MM-DD HH:mm:ss")), 1)
      ]),
      optional: _withCtx(({ record }) => [
        _createVNode(_component_a_space, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              shape: "round",
              type: "outline",
              onClick: ($event: any) => (openUpdateUserModal(record.id))
            }, {
              default: _withCtx(() => [
                _createTextVNode("修改 ")
              ]),
              _: 2
            }, 1032, ["onClick"]),
            (record.userRole != 'ban')
              ? (_openBlock(), _createBlock(_component_a_button, {
                  key: 0,
                  shape: "round",
                  type: "outline",
                  status: "danger",
                  onClick: ($event: any) => (banUser(record.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("封号 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              : (_openBlock(), _createBlock(_component_a_button, {
                  key: 1,
                  shape: "round",
                  type: "outline",
                  onClick: ($event: any) => (normalUser(record.id))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("解封 ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])),
            _createVNode(_component_a_popconfirm, {
              content: "确定要删除此题目吗?",
              type: "error",
              okText: "是",
              cancelText: "否",
              onCancel: _cache[3] || (_cache[3] = 
              () => {
                _unref(message).warning(`已取消`);
              }
            ),
              onOk: ($event: any) => (doDelete(record))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  shape: "round",
                  type: "outline",
                  status: "danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("删除 ")
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1032, ["onOk"])
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["data", "pagination"]),
    _createVNode(_component_a_modal, {
      width: "30%",
      visible: addUserVisible.value,
      placement: "right",
      onOk: addUser,
      onCancel: closeAddUserModel,
      unmountOnClose: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-align": "right",
          title: "个人信息",
          style: {"max-width":"480px","margin":"0 auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "昵称",
              label: "昵称 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: user.value.userName,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((user.value.userName) = $event)),
                  placeholder: "请输入用户昵称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "账号",
              label: "账号 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: user.value.userAccount,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((user.value.userAccount) = $event)),
                  placeholder: "请输入账号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userPassword",
              label: "密码 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input_password, {
                  modelValue: user.value.userPassword,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((user.value.userPassword) = $event)),
                  placeholder: "请输入密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "用户角色",
              label: "角色 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: user.value.userRole,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((user.value.userRole) = $event)),
                  placeholder: "请选择用户角色"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: "admin" }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "user" }, {
                      default: _withCtx(() => [
                        _createTextVNode("普通用户")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userProfile",
              label: "简介 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  modelValue: user.value.userProfile,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((user.value.userProfile) = $event)),
                  placeholder: "请输入用户简介"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_a_modal, {
      width: "30%",
      visible: updateUserVisible.value,
      placement: "right",
      onOk: updateUser,
      onCancel: closeUpdateUserModel,
      unmountOnClose: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_a_upload, {
            action: "/",
            fileList: file.value ? [file.value] : [],
            "show-file-list": false,
            onChange: onChange,
            "custom-request": uploadAvatar
          }, {
            "upload-button": _withCtx(() => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_a_avatar, {
                  size: 70,
                  shape: "circle"
                }, {
                  default: _withCtx(() => [
                    (_unref(userAvatarImg))
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          alt: "头像",
                          src: _unref(userAvatarImg)
                        }, null, 8, _hoisted_5))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_component_IconEdit)
                ])
              ])
            ]),
            _: 1
          }, 8, ["fileList"])
        ]),
        _createVNode(_component_a_form, {
          "label-align": "right",
          title: "个人信息",
          style: {"max-width":"480px","margin":"0 auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, {
              field: "昵称",
              label: "昵称 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: userInfo.value.userName,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((userInfo.value.userName) = $event)),
                  placeholder: "请输入用户昵称"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "账号",
              label: "账号 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  modelValue: userInfo.value.userAccount,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((userInfo.value.userAccount) = $event)),
                  placeholder: "请输入账号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "用户角色",
              label: "角色 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  modelValue: userInfo.value.userRole,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((userInfo.value.userRole) = $event)),
                  placeholder: "请选择用户角色"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_option, { value: "admin" }, {
                      default: _withCtx(() => [
                        _createTextVNode("管理员")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_option, { value: "user" }, {
                      default: _withCtx(() => [
                        _createTextVNode("普通用户")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, {
              field: "userProfile",
              label: "简介 :"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_textarea, {
                  modelValue: userInfo.value.userProfile,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((userInfo.value.userProfile) = $event)),
                  placeholder: "请输入用户简介"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}
}

})